import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

import { Image, ImageService } from '../../../common/services';
import {PubSubService} from '../../../common/services/pub-sub.service';
import {finalize} from 'rxjs/operators';

@Component({
  selector: 'p8-bdc-image-form',
  templateUrl: './image-form.component.html',
  styleUrls: ['./image-form.component.scss']
})
export class ImageFormComponent implements OnInit {
  @Input() file: File;

  @Input() title = '';
  @Input() description = '';
  @Input() url = '';

  imageForm: UntypedFormGroup;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private imageService: ImageService,
    private pubSubService: PubSubService
  ) { }

  ngOnInit() {
    this.loadImage();
    this.createForm();
  }

  loadImage() {
    if (this.file) {
      const reader = new FileReader();

      reader.onload = (event: any) => {
        this.url = event.target.result;
      };
      reader.readAsDataURL(this.file);
    }
  }

  createForm(title: string = this.title, description: string = this.description) {
    this.imageForm = this.formBuilder.group({
      title: [title, Validators.required],
      description: [description],
    });
  }

  isValid() {
    return this.imageForm.valid;
  }

  save() {
    const newImage: Image = {
      description: this.imageForm.value.description,
      title: this.imageForm.value.title,
      file: this.file
    };

    this.pubSubService.publish('loading', true);

    return this.imageService
      .upload(newImage)
      .pipe(finalize(() => this.pubSubService.publish('loading', false)));
  }

  patch(id: number) {
    const image: Image = {
      id: id,
      description: this.imageForm.value.description,
      title: this.imageForm.value.title
    };

    this.pubSubService.publish('loading', true);

    return this.imageService
      .patch(image)
      .pipe(finalize(() => {
        this.pubSubService.publish('loading', false);
      }));
  }
}
